import { t } from 'i18next';
import reportWebVitals from '../../reportWebVitals';

//Conversion Kb or Mb to GB for Consumption.
export function conversionToGB(type: any, number: any, d: any) {
    let result: any;
    let decimals = Math.round(number / 1024) === 0 ? 0 : d;
    switch (type) {
        case 'kB': {
            result = (number / Math.pow(1024, 2)).toFixed(decimals).toString().replace('.', ',') + ' ' + t('gigs');
            break;
        }
        case 'KB': {
            result = (number / Math.pow(1024, 2)).toFixed(decimals).toString().replace('.', ',') + ' ' + t('gigs');
            break;
        }
        case 'mb': {
            result = (number / 1024).toFixed(decimals).toString().replace('.', ',') + ' ' + t('gigs');
            break;
        }
        case 'MB': {
            result = (number / 1024).toFixed(decimals).toString().replace('.', ',') + ' ' + t('gigs');
            break;
        }
        default: {
            break;
        }
    }
    return result || '';
}

/* 0 GB
1 - 1023 kB (< 1 MB --> sin decimales)
1,00 - 1023,99 MB (1 MB y < 1 GB  --> 2 decimales)
1,00 - XX,XX GB (2 decimales) */
//Conversion Kb to Mb or MB to GB for Details
// 0-1024 --> kb
export function conversionKBtoMbOrGB(number: any) {
    let aux: any;
    let auxMb: any;
    let aux3: any;
    if (number === 0) {
        return `0 ${t('gigs')}`;
    } else if (number <= 1023) {
        aux = 1 + ' ' + t('megabyte');
        return aux;
    } else if (number >= 1024) {
        auxMb = number / 1024;
        if (auxMb >= 1024) {
            aux3 = (auxMb / 1024).toFixed(2).toString().replace('.', ',') + ' ' + t('gigs');
            return aux3;
        } else {
            aux3 = auxMb.toFixed(0) + ' ' + t('megabyte');
            return aux3;
        }
    }
}

//Separate mobile numbers 3 by 3: 666 777 888
export function formatMobileNumber(number: any) {
    let phone = '';
    if (number) {
        let length = number?.length;
        let aux1 = number?.charAt(0);
        let arrExtraSpent = ['901', '902', '803', '806', '807', '905', '118'];
        if (length === 9) {
            if (aux1 === '6' || aux1 === '7') {
                phone = [number.slice(0, 3), ' ', number.slice(3, 6), ' ', number.slice(6, 9)].join('');
            } else {
                let aux3 = number.substring(0, 3);
                let found = arrExtraSpent.find((e) => e === aux3);
                if (found) {
                    phone = [number.slice(0, 3), ' ', number.slice(3, 6), ' ', number.slice(6, 9)].join('');
                } else {
                    phone = [
                        number.slice(0, 2),
                        ' ',
                        number.slice(2, 5),
                        ' ',
                        number.slice(5, 7),
                        ' ',
                        number.slice(7, 9),
                        ' ',
                        number.slice(9, 11),
                    ].join('');
                }
            }
        } else if (length === 4) {
            phone = number;
        } else if (length === 5) {
            phone = [number.slice(0, 3), ' ', number.slice(3, 5)].join('');
        } else if (length === 6) {
            phone = [number.slice(0, 3), ' ', number.slice(3, 6)].join('');
        } else if (length > 9) {
            phone = [
                number.slice(0, 3),
                ' ',
                number.slice(3, 6),
                ' ',
                number.slice(6, 9),
                ' ',
                number.slice(9, 12),
                ' ',
                number.slice(12, 15),
            ].join('');
        } else if (length === 3) {
            phone = number;
        }
    }
    return phone;
}

//Format:
//      If type is 'rate' --> 5 €
//      If type is 'spent' --> 5,00 €
export function formatPrices(number: any, type: any) {
    let price: any;
    if (number == '') {
        number = 0;
    }
    switch (type) {
        case 'rate': {
            price = number + ' ' + t('euro');
            break;
        }
        case 'spent': {
            price = parseFloat(number).toFixed(2).replace('.', ',') + ' ' + t('euro');
            break;
        }
        default: {
            break;
        }
    }
    return price;
}

// Format time for consumtion: only seconds to min. Ej: 20480 s -->  341 min
export function formatTimeConsumption(number: any) {
    let aux: any;
    if (number <= 60) {
        aux = '0 min';
    } else if (number > 60) {
        aux = (number / 60).toFixed(0) + ' min ';
    }
    return aux;
}

// Format time for detail: seconds to min and hours. Ej: 20480 s -->  5 h 41 m
export function formatTimeDetail(number: any) {
    let aux;
    let auxMins;
    let auxHours;
    let aux2;
    if (number <= 60) {
        aux = number + ' s';
        return aux;
    } else if (number >= 60) {
        auxMins = number / 60;
        aux2 = Math.round(auxMins % 60);
        if (auxMins >= 60) {
            if (aux2 === 0) {
                auxHours = Math.trunc(auxMins / 60) + 'h';
            } else {
                auxHours = Math.trunc(auxMins / 60) + ' h ' + aux2 + ' m';
            }
            return auxHours;
        } else {
            aux = (number / 60).toFixed(0) + ' m';
            return aux;
        }
    }
}

export function hideEmailCharacters(email: string) {
    let chars = 1;
    let res = email.replace(
        /[a-z0-9\-_.]+@/gi,
        (c) =>
            c.substr(0, chars) +
            c
                .split('')
                .slice(chars, -1)
                .map((v) => '*')
                .join('') +
            '@',
    );
    return res;
}

export function hideMobileCharacters(mobile: any) {
    let res = mobile.slice(0, 1) + mobile.slice(1).replace(/.(?=..)/g, '*');
    return res;
}
